import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchProfile } from "../../../store/slices/profileSlice";
import Loader from "../Loader";
import UnauthorizedPage from "./UnauthorizedPage";

interface ApplicationAccessGuardProps {
  children: React.ReactNode;
}

const ApplicationAccessGuard: React.FC<ApplicationAccessGuardProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { profile, loading, profileError } = useAppSelector((state) => state.profile);
  const isAdminRoute =
    pathname === "/admin" ||
    pathname.startsWith("/admin/") ||
    pathname === "/tuition/admin/canned-responses";

  useEffect(() => {
    if (!isAdminRoute && !profile && !loading && !profileError) {
      dispatch(fetchProfile());
    }
  }, [dispatch, isAdminRoute, profile, loading, profileError]);

  if (isAdminRoute) {
    return <>{children}</>;
  }

  if (loading || (!profile && !profileError)) {
    return <Loader />;
  }

  if (profileError || !profile) {
    return <UnauthorizedPage />;
  }

  return <>{children}</>;
};

export default ApplicationAccessGuard;